import React, { useRef } from "react";
import PropTypes from "prop-types";
import { FormMenu } from "../../../components/Buttons";
import TechKeyForm from "../components/wizard/TechKeyForm";

import { connect } from "react-redux";
import { frontloadConnect } from "react-frontload";
import { loadAvailableKeys } from "../../Product/actions/keys";

const frontload = async (props) => {
  const { companyName, companyKeys, getAvailableKeys } = props;
  // console.log('>> prefetching:', companyName, getAvailableKeys);
  await getAvailableKeys({ companyName, companyKeys: [] });
};
const mapStateToProps = (state) => {
  return {
    techKeys: state.key.avialableKeys,
  };
};
const mapDispatchToProps = (dispatch) => ({
  getAvailableKeys: (...args) => dispatch(loadAvailableKeys(...args)),
});

const TechKeyListFormHolder = (props) => {
  const {
    className = "",
    model,
    techKeys = [],
    onCancel,
    disabled,
    onSave: onSaveProp,
  } = props;
  const formRef = useRef(null);

  const getModel = () => formRef.current.getModel();

  const handleSave = () => {
    const model = getModel();
    onSaveProp && onSaveProp(model);
  };

  console.log("TechKeyListFormHolder.render()", props);
  return (
    <div className={className}>
      <TechKeyForm
        ref={formRef}
        model={model}
        techKeys={techKeys}
        disabled={disabled || model.id || (model.number && model.number !== "")}
      />
      <FormMenu
        className="margin-big-top w3-border-top pad-big w3-light-grey"
        style={{
          marginLeft: "-1em",
          marginRight: "-1em",
          marginBottom: "-1em",
        }}
        onSave={handleSave}
        onCancel={onCancel}
        saveBtnName="saveTechKeyBtn"
        cancelBtnName="cancelTechKeyBtn"
        saveHidden={disabled}
      />
    </div>
  );
};

TechKeyListFormHolder.propTypes = {
  className: PropTypes.string,
  techKeys: PropTypes.array,
  companyName: PropTypes.string,
  companyKeys: PropTypes.array,
  model: PropTypes.shape({}).isRequired,
  getAvailableKeys: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(
  frontloadConnect(frontload, {
    onMount: true,
    onUpdate: false,
  })(TechKeyListFormHolder),
);
